import copyIcon from '../../assets/copy.svg'
import { createCellOption } from 'public/components/kye-table2/components/body/cell-option'
import { Message } from 'element-ui'
import { isFunction } from 'lodash'
const MASK_KEY = 'Mask'
const VIRTUAL_KEY = 'Virtual'

const CellOption = createCellOption()
const COPY = 'copy'

const CUSTOM = 'custom'

const className = 'table2-warp-custom-copy-cell'

// 复制内容到剪贴板
function copyTextToClipBoard (text, msg = '已复制到剪贴板') {
  const element = document.createElement('textarea')

  element.value = text

  element.setAttribute('readonly', '')

  element.style.position = 'absolute'
  element.style.left = '-9999px'

  document.body.appendChild(element)
  element.select()
  element.setSelectionRange(0, element.value.length)


  try {
    document.execCommand('copy')
    Message.success(msg)
  } catch (e) {
    console.error(e)
    throw new Error(e)
  }

  element.remove()
}


export function createCopyCellRender ({vm}) {
  return function (h, props) {
    const {
      rowData,
      column,
      value,
      rowIndex,
      columnIndex,
      handleEvent
    } = props
    const { widgetType, copyText, iconFunc, iconRender, iconTip = '复制', showIconTooltip = true, iconAlign = 'left' } = column || {}
    const content = isFunction(iconTip) ? iconTip(props) : iconTip
    const mouseenter = (event) => {
      showIconTooltip && handleEvent && handleEvent(event, { _isForce: true, rowData, rowIndex, column, eventType: 'copy-mouse-enter', execRow: false, event, columnIndex, value: content })
    }
    const mouseleave = (event) => {
      showIconTooltip && handleEvent && handleEvent(event, { rowData, rowIndex, column, value: content, eventType: 'copy-mouse-leave', execRow: false, event, columnIndex })
    }
    const copyIconVNode = h('img', {
      class: 'copy-icon',
      attrs: {
        src: copyIcon,
      },
      ref: 'copyIcon',
      on: {
        mouseenter,
        mouseleave,
        click: () => {
          // 自定义复制iconFunc点击事件, 自行处理
          if (typeof iconFunc === 'function' && iconFunc(props) === true) {
            return
          }
          let text = value
          if (copyText) {
            text = typeof copyText === 'function' ? copyText(props) : copyText
          }
          if (!text) {
            Message.warning(`无复制内容`)
            return
          }
          copyTextToClipBoard(text)
        }
      }
    })
    const copyContent = h('div', {
      class: 'table2-warp-custom-copy-cell-content',
      on: {
        click: (e) => {
          const { rowData, column } = props || {}
          const { key } = column || {}
          if (rowData) {
            if (rowData[key + MASK_KEY] !== undefined || rowData[key + VIRTUAL_KEY] !== undefined) {
              e.stopPropagation()
            }
          }
          vm.handleDecrypt(props)
        }
      }
    }, [
      h(CellOption, {
        props,
      })
    ])

    const iconVnode = () => {
      if (widgetType === COPY) {
        return copyIconVNode
      } else if (widgetType === CUSTOM && iconRender) {
        return typeof iconRender === 'function' ? iconRender(h, props) : iconRender
      }
      return null
    }
    const icon = iconVnode()
    const vnodes = [icon, copyContent]
    if (iconAlign === 'right') {
      vnodes.reverse()
    }
    return h('div', { class: className }, vnodes)
  }
}



// WEBPACK FOOTER //
// ./src/public/components/query-table/table2/feature/copy-cell-render.js